export const createSourceInfo = ({
    videoName,
    mixpanelPageName,
    bigQueryPageName
}) => ({
    videoName,
    mixpanel: {
        pageName: mixpanelPageName
    },
    bigQuery: {
        pageName: bigQueryPageName
    }
});
